export const STORAGE_KEY = "layoutPreferences";

export enum LayoutPreferenceKey {
  NavigationCollapsed = "isNavigationCollapsed",
  DropZoneOpen = "isDropZoneOpen",
}

export interface LayoutPreferences {
  [LayoutPreferenceKey.NavigationCollapsed]?: boolean;
  [LayoutPreferenceKey.DropZoneOpen]?: boolean;
}

export function isLayoutPreferences(value: unknown): value is LayoutPreferences {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  return Object.values(value).every((v) => typeof v === "boolean" || typeof v === "undefined");
}
